import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export class LocalNav {
  constructor() {
    this.DOM = {};
    this.DOM.localNav = document.querySelectorAll('[data-localnav]');

    this.CURRENT_CLASS = 'is-current';
    if (this.DOM.localNav.length === 0) return;

    this.init();
  }

  init() {
    // 各ローカルナビゲーションに対してScrollTriggerを設定
    this.DOM.localNav.forEach((nav) => {
      const sections = document.querySelectorAll('[data-localnav-section]');
      const items = nav.querySelectorAll('[data-localnav-item]');

      sections.forEach((sec) => {
        const id = sec.getAttribute('id');
        if (!id) return;

        const targetAnchor = nav.querySelector(`a[href="#${id}"]`);
        if (!targetAnchor) return;

        // アンカーリンクの直近の [data-localnav-item] を取得
        const currentItem = targetAnchor.closest('[data-localnav-item]');
        if (!currentItem) return;

        ScrollTrigger.create({
          trigger: sec,
          start: 'top 25%',
          end: 'bottom 25%',
          // markers: true,
          onToggle: (self) => {
            if (self.isActive) {
              // 1. 一旦ナビ内のすべての要素から is-current を解除
              items.forEach((ele) => ele.classList.remove(this.CURRENT_CLASS));

              // 2. 親方向に向かってすべての [data-localnav-item] に is-current を付与（階層付け）
              this.highlightItemAndParents(currentItem);
            }
          }
        });
      });
    });
  }

  /**
   * 対象のアイテムおよび親階層にあるすべての [data-localnav-item] に is-current を追加
   */
  highlightItemAndParents(item) {
    let current = item;

    while (current && current !== document.body) {
      // 自身または祖先要素が [data-localnav-item] であれば is-current を付与
      if (current.matches('[data-localnav-item]')) {
        current.classList.add(this.CURRENT_CLASS);
      }
      // 親要素へ遡る
      current = current.parentElement;
    }
  }
}
